import PropTypes from 'prop-types';
import React from 'react';
import TierPricingPage from './TierPricingPage';

function PricingPlans({ embedded = true }) {
  return <TierPricingPage embedded={embedded} />;
}

PricingPlans.propTypes = {
  embedded: PropTypes.bool,
};

PricingPlans.defaultProps = {
  embedded: true,
};

export default PricingPlans;
